module.exports = __webpack_public_path__ + "img/Grinswettbewerb.a23bfc19.jpg";